/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_Retention_Access_TokenInputs */

const tr_cerez_retention_access_token = /** @type {(inputs: Cerez_Retention_Access_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erişim anahtarının süresi kadar (yaklaşık 1 saat), oturum sürdükçe yenilenir`)
};

const en_cerez_retention_access_token = /** @type {(inputs: Cerez_Retention_Access_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As long as the access key is valid (about 1 hour), renewed while the session lasts`)
};

const de_cerez_retention_access_token = /** @type {(inputs: Cerez_Retention_Access_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So lange der Zugangsschlüssel gilt (etwa 1 Stunde), wird während der Sitzung erneuert`)
};

const ru_cerez_retention_access_token = /** @type {(inputs: Cerez_Retention_Access_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пока действует ключ доступа (около 1 часа), обновляется, пока длится сессия`)
};

/**
* | output |
* | --- |
* | "As long as the access key is valid (about 1 hour), renewed while the session lasts" |
*
* @param {Cerez_Retention_Access_TokenInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_retention_access_token = /** @type {((inputs?: Cerez_Retention_Access_TokenInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_Retention_Access_TokenInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_retention_access_token(inputs)
	if (locale === "de") return de_cerez_retention_access_token(inputs)
	if (locale === "ru") return ru_cerez_retention_access_token(inputs)
	return tr_cerez_retention_access_token(inputs)
});